import Player from '@vimeo/player';

// 参考: https://jomo-p.co.jp/blog/javascript-open-a-modal-window-to-play-vimeo/
// HTML
// <button type="button" data-js="modal-video" data-video-id="1032217370" data-video-h="32267fa896"></button>
class ModalVideoPlayer {
  constructor(el) {
    this.dom = {el: el};
    this.dom.overlay = null;

    this.window = window;
    this.html = document.querySelector('html');
    this.body = document.body;

    this.scrollbarWidth = window.innerWidth - this.body.scrollWidth;
    this.touchStartY = null;

    this.player = null;
    this.videoId = this.dom.el.dataset.videoId;
    this.videoH = this.dom.el.dataset.videoH;

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.touchMoveHandler = this.touchMoveHandler.bind(this);
    this.overlayHandler = this.overlayHandler.bind(this);

    this.init();
  }

  init() {
    this.setHtml();
      
    this.window.addEventListener('touchstart', function(event) {
      this.touchStartY = event.changedTouches[0].screenY;
    });
    this.dom.el.addEventListener('click', this.openModal);
  }

  openModal() {
    // this.setHtml();

    this.player = new Player(this.dom.overlay.querySelector('[data-js="modal-iframe"]'));
    this.html.style.overflow = 'hidden';
    this.body.style.overflow = 'hidden';
    if (this.scrollbarWidth) {
      this.html.style.paddingRight = this.scrollbarWidth + 'px';
    }
    this.dom.overlay.style.display = 'block';
    this.dom.overlay.style.opacity = 1;
    this.dom.overlay.style.transition = 'opacity 0.3s';
    // setTimeout(() => {
    //   this.player.play().catch(() => {});
    //   this.player.pause();
    // }, 1000)

    setTimeout(() => {
      this.player.setVolume(1);
      this.player.play();
      // this.player.play().catch((err) => alert(err));
    }, 300)
    this.dom.overlay.querySelector('[data-js="modal-closer"]').addEventListener('click', this.closeModal);
    this.dom.overlay.addEventListener('click', this.overlayHandler);
    this.window.addEventListener('touchmove', this.touchMoveHandler, { passive: false });
  }

  closeModal() {
    this.body.style.removeProperty('overflow');
    this.html.style.removeProperty('overflow');
    this.html.style.removeProperty('padding-right');
    this.window.removeEventListener('touchmove', this.touchMoveHandler);
    this.dom.overlay.style.transition = 'opacity 0.3s';
    this.dom.overlay.style.opacity = 0;
    setTimeout(() => {
      this.dom.overlay.scrollTop = 0;
      this.dom.overlay.style.display = 'none';
      this.dom.overlay.style.removeProperty('style');
      this.html.style.removeProperty('style');
    }, 300);
    this.player.pause();
  }

  touchMoveHandler(e) {
    const currentY = e.changedTouches[0].screenY;
    const height = this.dom.overlay.offsetHeight;
    const isTop = this.touchStartY <= currentY && this.dom.overlay.scrollTop === 0;
    const isBottom = this.touchStartY >= currentY && this.dom.overlay.scrollHeight - this.dom.overlay.scrollTop === height;
    if (isTop || isBottom) {
      e.preventDefault();
    }
  }

  overlayHandler(e) {
    if (!e.target.closest('[data-js="modal-contents"]')) {
      this.closeModal();
    }
  }

  setHtml() {
    const videoH = (this.videoH) ? 'h=' + this.videoH + '&': '';
    const html = `<div class="c-modal" data-js="modal">
      <div class="c-modal__container">
        <div class="c-modal__inner">
          <div class="c-modal__contents" data-js="modal-contents">
            <div class="c-modal__vimeo">
              <iframe src="https://player.vimeo.com/video/${this.videoId}?${videoH}badge=0&player_id=0&app_id=58479&autoplay=0&muted=1&loop=1&autopause=1" width="1920" height="1080" frameBorder="0" allow="autoplay; fullscreen" allowFullScreen title="SPECIAL MOVIE 会社紹介動画" data-js="modal-iframe"></iframe>
            </div>
            <div class="c-modal-close">
              <button type="button" class="c-modal-close__inner" data-js="modal-closer"></button>
            </div>
          </div>
        </div>
      </div>
    </div>`;
    document.body.insertAdjacentHTML('afterend', html);

    this.dom.overlay = document.querySelector('[data-js="modal"]');
  }
}

export default ModalVideoPlayer